const _ = require("lodash");
const moment = require("moment");

const isPastExpiration = subscription => {
	const expiresAt = _.get(subscription, "expiresAt");
	return moment().isAfter(moment(expiresAt));
};

/**
 * Determines whether a subscription is active, autorenews, and is past its
 * expiration date (aka is active due to a grace period we extend to some
 * subscriptions). If so, it will expire soon, and we may handle these
 * subscriptions differently when it comes to switching their type.
 */
const isActivePastExpiration = subscription => {
	const active = _.get(subscription, "active");
	const autoRenew = _.get(subscription, "autoRenew");
	const pastExpiration = isPastExpiration(subscription);
	return active && autoRenew && pastExpiration;
};

const getUpgradeInfo = subscription => {
	const {
		planType,
		purchaseOrderID,
		lastRenewedAt,
		active,
		trial, // backend only (same as isTrial)
		isTrial, // frontend only (same as trial)
		usedB2BBulkCode, // frontend only
		hasSwitched, // frontend only
	} = subscription || {};
	if (
		isPastExpiration(subscription) ||
		!active ||
		purchaseOrderID ||
		trial ||
		isTrial ||
		usedB2BBulkCode ||
		hasSwitched ||
		planType === "partnership"
	) {
		// Cannot upgrade if expired or a PO or a beta or has switched subscription
		// types since last payment or if it's a partnership subscription
		return {canUpgrade: false};
	}
	if (planType === "monthly") {
		return {canUpgrade: true};
	}
	const monthAfter = moment(lastRenewedAt).add(1, "month");
	if (planType === "yearly" && monthAfter.isAfter(moment())) {
		return {canUpgrade: true, upgradeUntil: monthAfter.toString()};
	}
	return {canUpgrade: false};
};

const getSwitchInfo = subscription => {
	const {planType, purchaseOrderID, isTrial, refundable} = subscription;
	const isPurchaseOrder = !!purchaseOrderID;

	// Cannot switch type if it's a partnership subscription
	if (planType === "partnership") {
		return {canSwitchType: false};
	}

	if (isPastExpiration(subscription)) {
		return {canSwitchType: false};
	}
	if (!isPurchaseOrder && (!refundable || planType === "monthly") && !isTrial) {
		return {canSwitchType: true};
	}
	return {canSwitchType: false};
};

module.exports = {
	isActivePastExpiration,
	getUpgradeInfo,
	getSwitchInfo,
};
